import { QrCodeScannerOutlined } from "@mui/icons-material";
import { Paper, Typography, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { useEffect } from "react";

interface Club {
  icon: JSX.Element;
  title: string;
  description: string;
  lat: any;
  lng: any;
  address1: any;
}

interface ListOfClubsProps {
  clubs: Club[];
  handleClick: (title: string , lat : any , lng : any) => void;
  t: (key: string) => string;
}

const ListOfClubs = ({ clubs, handleClick, t }: ListOfClubsProps) => {

    useEffect(()=>{
      console.log(clubs);
    })


  return (
    <Paper sx={{ width: 300, overflowY: "auto", height: "100%", maxHeight: 600, mr: 2, p: 2 }}>
      <Typography variant="h6" gutterBottom>
        {t("Clubs")}
      </Typography>
      {clubs.length > 0 ? (
        <List>
          {clubs.map((item, index) => (
            <ListItem
              key={index}
              component="div"
              onClick={() => handleClick(item.title, item.lat, item.lng)}
              sx={{
                "&:hover": { backgroundColor: "#f0f0f0" },
                borderRadius: 1,
                cursor: "pointer",
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>{item.icon}</ListItemIcon>
              <ListItemText
                primary={item.title}
                secondary={
                  <Typography variant="body2" color="textSecondary">
                    {item.address1}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography>Loading clubs...</Typography>
      )}
    </Paper>
  );
};

export default ListOfClubs;
